<!-- @format -->
<public-info>
  <style>
    .alert {
      color: red;
    }
  </style>
  <div class="contents_block skillsheet">
    <table class="detail_table">
      <tr class="detail_table-row">
        <th class="detail_table-heading">現在の対応状況</th>
        <td class="detail_table-data">
          <div class="sort-menu margin-spacing-2_right">
            <select name="status" class="sort-list">
              <option value="{key}" each="{key in Object.keys(Statuses)}">
                {Statuses[key]}
              </option>
            </select>
          </div>
          <!--/.sort-menu-->
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">公開する名前</th>
        <td class="detail_table-data">
          <div class="sort-menu margin-spacing-2_right">
            <select name="publish_name" class="sort-list js-skillsheet_name">
              <option value="{key}" each="{key in Object.keys(PublishNames)}">
                {PublishNames[key]}
              </option>
            </select>
          </div>
          <!--/.sort-menu-->
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">本名</th>
        <td class="detail_table-data realname">
          <div class="box_flex02">
            <div class="box_w50">
              <input
                class="text_input"
                type="text"
                name="realname"
                id="realname"
                placeholder="本名が入る"
                value="{state.realname}"
              />
            </div>
            <div
              class="note is-active margin-spacing-2_left"
              if="{status.publish_name=='realname'}"
            >
              ※こちらが公開されます
            </div>
          </div>
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">ニックネーム</th>
        <td class="detail_table-data nickname">
          <div class="box_flex02">
            <div class="box_w50">
              <input
                class="text_input"
                type="text"
                name="nickname"
                id="nickname"
                placeholder="ニックネームが入る"
                value="{state.nickname}"
              />
            </div>
            <div
              class="note is-active margin-spacing-2_left"
              if="{status.publish_name=='nickname'}"
            >
              ※こちらが公開されます
            </div>
          </div>
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">生年月日</th>
        <td class="detail_table-data">
          <div class="box_flex01">
            <div class="box_w50">
              <input
                class="text_input input_calendar"
                type="text"
                name="birthday"
                id="birthday"
                value="{state.birthday}"
                placeholder="日付を選択して下さい"
              />
            </div>
            <div class="box_w40 align_r">
              <input
                type="radio"
                name="publish_state_birthday"
                value="100"
                id="disclose01"
                class="radio_input"
              />
              <label for="disclose01" class="radio_label">公開</label>
              <input
                type="radio"
                name="publish_state_birthday"
                value="0"
                id="undisclose01"
                class="radio_input"
              />
              <label for="undisclose01" class="radio_label">非公開</label>
            </div>
          </div>
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">性別</th>
        <td class="detail_table-data">
          <div class="box_flex01">
            <div class="box_w20">
              <select name="sex" class="sort-list">
                <option value="{key}" each="{key in Object.keys(Sexes)}">
                  {Sexes[key]}
                </option>
              </select>
            </div>
            <div class="box_w40 align_r">
              <input
                type="radio"
                name="publish_state_sex"
                value="100"
                id="disclose02"
                class="radio_input"
                checked=""
              />
              <label for="disclose02" class="radio_label">公開</label>
              <input
                type="radio"
                name="publish_state_sex"
                value="0"
                id="undisclose02"
                class="radio_input"
              />
              <label for="undisclose02" class="radio_label">非公開</label>
            </div>
          </div>
        </td>
      </tr>
      <tr class="detail_table-row">
        <th class="detail_table-heading">居住地</th>
        <td class="detail_table-data">
          <div class="box_flex01">
            <div class="box_w20">
              <select name="pref" class="sort-list" onchange="{ onPref }">
                <option value="0">設定しない</option>
                <option value="{pref.id}" each="{ pref in state.prefMasters }">
                  { pref.jname }
                </option>
              </select>
            </div>
            <div class="box_w50" if="{ state.pref==48 }">
              <input
                class="text_input"
                type="text"
                name="country"
                id="country"
                value="{ state.country }"
              />
            </div>
            <div class="box_w40 align_r">
              <input
                type="radio"
                name="publish_state_pref"
                value="100"
                id="disclose03"
                class="radio_input"
                checked=""
              />
              <label
                for="disclose03"
                class="radio_label"
                if="{ state.pref != 0 }"
              >
                公開
              </label>
              <input
                type="radio"
                name="publish_state_pref"
                value="0"
                id="undisclose03"
                class="radio_input"
              />
              <label for="undisclose03" class="radio_label">非公開</label>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <!--/.detail_table-->

    <p class="note">
      ※本名、生年月日、性別は「会員情報」に登録されている内容を表示しています。
      <br />
      公開することで、特定の年齢層や性別をターゲットにした記事作成を希望しているクライアント様の目に留まる可能性が高くなります
    </p>

    <h3 class="heading-03 margin-spacing-5_top">
      自己PR
      <span
        class="status_label status_label-required margin-spacing-2_left"
      ></span>
    </h3>
    <!-- prettier-ignore -->
    <textarea
      class="textarea_input"
      name="description"
      placeholder="ここに自己PR文を記入してください"
    >{state.description}</textarea
    >
    <div class="box_flex03">
      <div
        class="button button-secondary-large"
        type="button"
        value="登録する"
        data-target=""
        onclick="{(e)=>onSubmit(e)}"
      >
        登録する
      </div>
    </div>
  </div>
  <script>
    import di from "dependeny-injection";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";

    export default {
      Statuses: {
        available: "対応可",
        negotiable: "応相談",
        // unavailable: "対応不可",
      },
      PublishNames: {
        realname: "本名",
        nickname: "ニックネーム",
      },
      Sexes: {
        1: "男性",
        2: "女性",
        3: "その他",
        4: "無回答",
      },
      state: {
        pref: 0,
        prefMasters: [],
        isRegistered: false,
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
        this.PublicInfoApi.request("index", "fetch").then((data) => {
          this.state = data || {};
          if (!this.state.birthday) {
            this.state.birthday = "2000-01-01";
          }
          this.update();
          if (data) {
            this.update({
              prefMasters: data.prefMasters,
              pref: data.pref,
              country: data.country,
              isRegistered: !!data.bizid,
            });
            const pref = data.pref ? data.pref : 0;
            this.onPref({ target: { value: pref } });
            this.$("[name=pref]").value = pref;
            this.$("[name=status]").value = data.status;
            this.$("[name=publish_name]").value = data.publish_name;
            this.$("[name=sex]").value = data.sex;
            this.$(`[name="publish_state_birthday"][value="0"]`).checked = true;
            this.$(`[name="publish_state_sex"][value="0"]`).checked = true;
            if (data.publish_state_birthday) {
              this.$(
                `[name="publish_state_birthday"][value="${data.publish_state_birthday}"]`
              ).checked = true;
            }
            if (data.publish_state_sex) {
              this.$(
                `[name="publish_state_sex"][value="${data.publish_state_sex}"]`
              ).checked = true;
            }
            if (data.publish_state_pref) {
              this.$(
                `[name="publish_state_pref"][value="${data.publish_state_pref}"]`
              ).checked = true;
            }
          }
        });
      },
      onMounted(props, state) {
        window.$("#birthday").flatpickr({
          locale: "ja",
          defaultDate: state.birthday,
        });
      },
      onPref(e) {
        this.update({ pref: e.target.value });
        // 設定しない
        if (e.target.value == 0) {
          this.$(`[name="publish_state_pref"][value='0']`).checked = true;
        }
        // 海外
        if (e.target.value == 48) {
          this.$("[name=country]").value = this.state.country;
        }
      },
      async onSubmit() {
        const params = {};
        this.$$("div.alert").forEach((e) => e.remove());

        this.$$(
          "select[name],textarea,input[type=text],input[type=radio]:checked"
        ).forEach((e) => {
          params[e.getAttribute("name")] = e.value;
        });
        let pass = true;
        Object.keys(params).forEach((name) => {
          if (params[name] === "") {
            const element = this.$(`[name=${name}]`);
            const parent = element.parentElement;
            const div = document.createElement("div");
            div.textContent = "入力されていません";
            div.classList.add("alert");
            parent.appendChild(div);
            pass = false;
          }
        });
        if (!pass) {
          return;
        }
        this.PublicInfoApi.request("index", "register", params)
          .then((data) => {
            if (!this.state.isRegistered) {
              this.update({ isRegistered: true });
              window.analytics.event("unlock_achievement", {
                achievement_id: "public_info_first_registration",
              });
            }
            di.toast.push("公開情報を更新しました", "success");
          })
          .catch((err) => {
            console.log(err);
            di.toast.push(err, "negative");
          });
      },
    };
  </script>
</public-info>
